import React from 'react';
import { classNames } from '../../../utils/classUtils';
import { CourierJson, CourierStatus } from '../../../types/bundleTypes';
import { CourierVehicle } from '../../../pages/couriers/courierVehicle';
import {
  BOOKED_SHIFT_COLOR,
  ONLINE_COLOR,
  OFFLINE_COLOR,
  ASSIGNED_COLOR,
} from './constants';
import { capitalize } from '../../../utils/strings';

function formatEtaOffset(etaOffsetSeconds: number): string {
  const negative = Math.sign(Number(etaOffsetSeconds)) === -1;
  const min = Math.abs(Math.trunc((Number(etaOffsetSeconds) % 3600) / 60));
  const sec = Math.abs(Number(etaOffsetSeconds) % 60)
    .toString(10)
    .padStart(2, '0');
  return `${negative ? '-' : ''}${min}:${sec}`;
}

const CourierList = ({
  couriers,
  selectedCourier,
  setSelectedCourier,
  assignedCourierIds,
  bookedCourierIds,
  showOnlyBookedCouriers,
}: {
  couriers: CourierJson[];
  selectedCourier: CourierJson;
  setSelectedCourier: (courier: CourierJson) => void;
  assignedCourierIds: Set<number>;
  bookedCourierIds: Set<number>;
  showOnlyBookedCouriers: boolean;
}) => {
  let bookedCouriersList: CourierJson[] | undefined;
  if (showOnlyBookedCouriers) {
    bookedCouriersList = couriers.filter(courier =>
      Array.from(bookedCourierIds).includes(courier.id)
    );
  }
  if (bookedCouriersList?.length > 0 || couriers.length > 0) {
    return (
      <div className="select-courier-modal__list">
        <div className="select-courier-modal__content">
          <div className="select-courier-modal__header">
            <span>NAME</span>
            <span>PREFERRED AREA</span>
            <span>NOTES</span>
            <span>ETA (min:sec)</span>
          </div>
          {(bookedCouriersList || couriers).map((courier, i) => (
            <div
              className={classNames(
                {
                  active: selectedCourier && selectedCourier.id === courier.id,
                  even: i % 2 === 0,
                },
                'select-courier-modal__line'
              )}
              style={{
                borderStyle: 'solid',
                borderLeftStyle: 'solid',
                borderLeftColor: assignedCourierIds.has(courier.id)
                  ? ASSIGNED_COLOR
                  : bookedCourierIds.has(courier.id)
                  ? BOOKED_SHIFT_COLOR
                  : courier.status === CourierStatus.Available
                  ? ONLINE_COLOR
                  : OFFLINE_COLOR,
                borderLeftWidth: '7px',
              }}
              key={courier.id}
              onClick={() => setSelectedCourier(courier)}
            >
              <span className="select-courier-modal__name">
                <span className="select-courier-modal__icon">
                  <CourierVehicle courier={courier} />
                </span>
                {courier.firstName} {courier.lastName}
              </span>
              <span className="select-courier-modal__pref-area">
                {courier.preferredGeoZones
                  .map(area => capitalize(area.split('_').join(' ')))
                  .join(', ')}
              </span>
              <span>{courier.notes}</span>
              <span className="select-courier-modal__eta">
                {formatEtaOffset(courier.etaOffsetSeconds)}
              </span>
            </div>
          ))}
        </div>
      </div>
    );
  } else {
    return (
      <div className="select-courier-modal__content">
        <h5>No couriers found</h5>
      </div>
    );
  }
};

export default CourierList;
